import 'src/helpers/customFocusVisible';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { history, store } from './store/configureStore';
import Notifications from 'src/utils/Notifications';
import I18N from './i18n';
import Security from './utils/Security';
import { PageTitleProvider } from 'src/ui/library/PageTitle';
import routes from 'src/routes';
import theme from 'src/ui/library/theme';
import 'src/scss/index.scss';
import '../src/scss/new-scss/index.scss';
import browserPatches from 'src/helpers/browserPatches'; // eslint-disable-line
import { polyfills } from 'src/helpers/polyfillInit';
import ErrorBoundary from 'src/utils/ErrorBoundary';
import 'eymp-uicomps/styles/index.scss';

// eslint-disable-next-line no-undef
__webpack_nonce__ = '{{nonce}}';

// attempt at addressing cache issue
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();
  });
}
const rootElement = createRoot(document.getElementById('root'));

class App extends React.Component {
  constructor(props) {
    super(props);
    polyfills();
  }

  render() {
    return (
      <ErrorBoundary>
        <Provider store={store}>
          <MuiThemeProvider theme={theme()}>
            <Security history={history}>
              <PageTitleProvider history={history}>
                <I18N>
                  <Notifications>
                    <ConnectedRouter history={history}>{routes}</ConnectedRouter>
                  </Notifications>
                </I18N>
              </PageTitleProvider>
            </Security>
          </MuiThemeProvider>
        </Provider>
      </ErrorBoundary>
    );
  }
}

// render(<App />, document.getElementById('root'));
rootElement.render(<App />);
